import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useProductDashboardKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [netSlsQty, netSlsGmvVal, retQty, ordQty] = getMeasures([
    'netSlsQtyExpOD',
    'netSlsGmvValExpOD',
    'retQtyRateExpOD',
    'ordQty',
  ]);

  return [
    measureKpi(netSlsQty),
    measureKpi(netSlsGmvVal),
    customKpi('oorderedGMVGrowth', {
      titleId: 'insights.measure.oorderedGMVGrowth.name',
      descriptionId: 'insights.measure.oorderedGMVGrowth.description',
    }),
    customKpi('oorderedGMVGrowthValue', {
      titleId: 'insights.measure.oorderedGMVGrowthValue.name',
      descriptionId: 'insights.measure.oorderedGMVGrowthValue.description',
    }),
    measureKpi(ordQty),
    measureKpi(retQty),
    customKpi('averagePricePerItem', {
      titleId: 'insights.measure.averagePricePerItem.name',
      descriptionId: 'insights.measure.averagePricePerItem.description',
    }),
  ];
}

export function ProductDashboardInfoContent() {
  const kpis = useProductDashboardKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulDescriptionId="insights.product_tab.info.content.why_is_this_view_useful_description"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
